import React from 'react';

interface LocalTimeProps {
  utcDateTime: string;
}

const LocalTime: React.FC<LocalTimeProps> = ({ utcDateTime }) => {
  const formatLocalTime = (utc: string): string => {
    const date = new Date(utc);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  return <span>{formatLocalTime(utcDateTime)}</span>;
};

export default LocalTime;
